import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect, Switch, Route } from 'react-router-dom'

import Login from 'app/domains/routes/Login'
import Start from 'app/domains/routes/Start'
import Spinner from 'app/components/Spinner/Spinner'
import GlobalLoaderOrSpinner from 'app/components/Loaders/GlobalLoaderOrSpinner'
import { getOrganizationDomainFromUrl } from 'helpers/urlHelper'

class GuestRouter extends Component {
  static propTypes = {
    pathname: PropTypes.string,
    pending: PropTypes.bool,
    userInfoFromHash: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    isTranslationsLoadedForLoginPage: PropTypes.bool,
  }

  checkIsWaiting = () => {
    const { pending, userInfoFromHash } = this.props

    return userInfoFromHash || pending
  }

  redirect = () => {
    const domain = getOrganizationDomainFromUrl(document.location.hostname)

    if (domain === 'mondelez' || domain === 'mondelezinternational') {
      if (process.env.SERVER === 'production') {
        document.location.href = 'https://mondelezinternational.prohabits.com/login'
      }

      if (process.env.SERVER === 'staging') {
        document.location.href = 'https://mondelez.stg.prohabits.com/login'
      }
    }

    return <Redirect to="/login" />
  }

  render() {
    if (this.checkIsWaiting()) {
      return <Spinner title="Logging in" style={{ backgroundColor: '#f8f9fa' }} />
    }

    return this.props.isTranslationsLoadedForLoginPage ? (
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/start" component={Start} />
        {this.redirect()}
      </Switch>
    ) : (
      <GlobalLoaderOrSpinner />
    )
  }
}

GuestRouter.displayName = 'GuestRouter'

export default GuestRouter
